import {
  Component,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import {ExternalSourceProviderEnum, PAGE} from '@gp-angular/shared/schema';
import { UserService } from '@gp-angular/service/user';
import {ProviderService} from "@gp-angular/service/provider";
import { NotificationDTO } from '@noventi/gp-platform/users';

@Component({
	selector: 'gp-provider-menu-aside',
	templateUrl: './menu-aside.component.html',
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProviderMenuAsideComponent {

	public readonly PAGE = PAGE;

	public readonly ExternalSourceProviderEnum = ExternalSourceProviderEnum;

	public permission$ = this.userService.getPermission$();

  @Input()
  public menuSideCollapsed: boolean = false;

  @Output()
  goToRelease = new EventEmitter<void>();

  @Input()
  public newsList: Array<NotificationDTO>;

	public externalSource: ExternalSourceProviderEnum = this._providerService.getExternalSource();

	constructor(
		private userService: UserService,
		private _providerService: ProviderService
	) {
	}

  onReleaseNotesClick(): void {
    this.goToRelease.emit();
  }
}
